import BlocksTop from "components/Home/BlocksTop";
import React from "react";

const Dashboard = () => {
  return (
    <div>
      <BlocksTop />
    </div>
  );
};

export default Dashboard;
